import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import AppLayout from '../../../component/appLayout';
import {
  Group,
  LeftDiv,
  LeftHeader,
  MainDiv,
  Profile,
  Project,
  ProjectBox,
  ProjectDetail,
  Title,
  Invoice,
  Table,
  Empty,
  Overlay,
  ProfileImg,
  EditIcon,
  TableWrapper,
  DropDiv,
  TableTr,
  LeftContentDiv,
  TableHead,
  TableHeadGroup,
  TableHeader,
  TableDataGroup,
  TableData
} from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import Modal from '../../../component/modals/modal';
import DeleteModal from '../../../component/modals/deleteModal';
import AddMemberModal from '../../../component/modals/addMemberModal';
import { useHistory, useParams } from 'react-router-dom';
import {
  deleteCustomerMember,
  getCustomerList,
  getCustomerMembersList,
  getCustomersInvoiceList,
  getCustomersProjectList,
  getIndividualCustomerDetail,
  updateCustomerData
} from '../../../services/customerServices';
import {
  CustomerDetailsInterface,
  CustomerInvoiceData,
  CustomerProjectListInterface,
  MemberInputInterface
} from '../../../interfaces/CustomerInterface';
import {
  calculateDueTime,
  currencyWithDecimal,
  getColorIndex,
  getFirebaseUrlFromFile,
  getFormattedDate,
  isEmpty
} from '../../../helpers/common';
import { currencySymbols } from '../../../global/row';
import {
  CustomerDetailMoreMenu,
  EMPTY_STATE_SIZE,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  ICON_SIZE,
  MENU_OPTIONS,
  PROJECT_ICON_TYPE
} from '../../../global/constants';
import CustomerDetailLoading from '../../../component/loading/customerDetailLoading';
import CustomerModal from '../../../component/modals/customerModal';
import { captureException } from '../../../services/logService';
import { trackAnalyticActivity } from '../../../services/analyticsService';
import CustomerEditModal from '../../../component/modals/customerModal/customerEditModal';
import SuccessFullModel from '../../../component/modals/successfullModal';
import CustomerDetailRight from './customerDetailRightSection';
import { INVOICE_ANALYTICS } from '../../../global/analyticsConstants';
import { useMobileDevice } from '../../../global/useMobile';
import { Dropdown, DropdownItem } from '../../../component/dropdown';
import { rootStore } from '../../../mobx/rootStore';
import AddInvoiceModal from '../../../component/modals/addInvoiceModal';
import { ProjectModel } from '../../../mobx/models/project';
import { observer } from 'mobx-react-lite';
import BottomSubNavigation from '../../../component/bottomNavigation/subNavigation';
import ResponsiveHeader from '../../../component/responsiveHeader';
import ProjectCard from '../../../component/projectCard';
import { ROUTES } from '../../../routes/urls';
import IconButton from '../../../component/button/iconButton';
import BottomNavigationItem from '../../../component/bottomNavigation/subNavigation/bottomNavigationItem';
import EmptyStateV2 from '../../../component/emptyState';
import Image from '../../../component/image';
import { CompanyDetails, CompanyName, CustomerName, InvoiceNumber } from '../../invoices/styles';

const CustomerDetail: React.FC = () => {
  //Refs
  const invoiceButtonRef = useRef<React.RefObject<HTMLDivElement>[]>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);

  //States
  const [deleteModelOpen, setDeleteModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteMemberLoading, setDeleteMemberLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState<MemberInputInterface>();
  const [isInvoiceModel, setIsInvoiceModel] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [openCustomerModel, setOpenCustomerModel] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSuccessfulModalOpen, setIsSuccessfulModalOpen] = useState(false);
  const [clientLoginUrl, setClientLoginUrl] = useState('');
  const [selectedInvoice, setSelectedInvoice] = useState<string | null>(null);
  const [customerInvoiceList, setCustomerInvoiceList] = useState<CustomerInvoiceData[]>([]);
  const [customerProjectList, setCustomerProjectList] = useState<CustomerProjectListInterface[]>([]);

  //mobx store variables
  const { projectStore, workspaceStore, customerStore } = rootStore;
  const { projects } = projectStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const { individualCustomer, newCustomer } = customerStore;

  //Other variable
  const isMobile = useMobileDevice();
  const history = useHistory();
  const params: { id: string } = useParams();

  // for open successful model
  const handleOnclickOpenModel = () => {
    setIsSuccessfulModalOpen(true);
  };

  // for close successful model
  const handleOnclickCloseModel = () => {
    setIsSuccessfulModalOpen(false);
  };

  // handel modal close
  const handleCloseModal = useCallback((clientUrl?: string) => {
    setIsModalOpen(false);
    if (clientUrl) {
      setClientLoginUrl(clientUrl);
      handleOnclickOpenModel();
    }
  }, []);

  // handel delete modal close
  const close = () => {
    setDeleteModalOpen(false);
    setSelectedItem(undefined);
  };

  // load customer project
  const loadCustomerProject = useCallback(async () => {
    if (!isEmpty(workspace?.id) && !isEmpty(params?.id)) {
      const projects = await getCustomersProjectList(params?.id);
      const updatedProjectList = await projects?.map((project: CustomerProjectListInterface) => {
        const users = project?.ProjectUsers?.map((projectUser) => {
          const matchingUserData = workspace?.users?.find(
            (userData: { id: string }) => userData?.id === String(projectUser)
          );
          return matchingUserData || projectUser;
        });
        const updated = { ...project, users: users, name: project?.Name };
        return updated;
      });
      setCustomerProjectList(updatedProjectList || []);
    }
  }, [params?.id, workspace?.id, workspace?.users]);

  // load initial data
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(workspace?.id) && !isEmpty(params?.id)) {
        setLoading(true);
        await Promise.all([getIndividualCustomerDetail(params?.id), getCustomerList()]);
        loadCustomerProject();
        const response = await Promise.all([getCustomersInvoiceList(params?.id), getCustomerMembersList(params?.id)]);
        const invoices = response?.[0] || [];
        setCustomerInvoiceList(invoices);
      }
    } catch (error) {
      captureException(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [loadCustomerProject, params?.id, workspace?.id]);

  useEffect(() => {
    loadData();
    return () => {
      customerStore.clearCustomerDetail();
      setCustomerProjectList([]);
      setCustomerInvoiceList([]);
      customerStore.setIndividualCustomerDetail({});
    };
  }, [loadData, customerStore]);

  // for open modal
  const OpenModal = useCallback(() => {
    rootStore.projectStore.createProjectInput.setCustomerId(params?.id);
    history.push(ROUTES.CREATE_PROJECT);
  }, [history, params?.id]);

  // handel click new invoice
  const onClickNewInvoice = () => {
    trackAnalyticActivity(INVOICE_ANALYTICS.NEW_INVOICE_CLICKED);
    setIsInvoiceModel(!isInvoiceModel);
  };

  // handel close invoice modal
  const handleClose = () => {
    setIsInvoiceModel(false);
  };

  // Delete customer detail
  const onClickDelete = useCallback(
    (item: CustomerDetailsInterface) => {
      customerStore.setCustomerDetail(item);
      setIsDeleteOpen(true);
    },
    [customerStore]
  );

  // close delete modal
  const onCloseDeleteModal = useCallback(() => {
    setIsDeleteOpen(false);
    setSelectedItem(undefined);
  }, []);

  // handel delete customer
  const onDeleteCustomer = useCallback(
    async (item: { id: string }) => {
      try {
        setLoading(true);
        let response;
        if (!isEmpty(item?.id)) {
          response = await updateCustomerData(item?.id, { IsArchived: true });
        }
        if (response) {
          onCloseDeleteModal();
          history.push(ROUTES.CUSTOMER);
          rootStore.alertNotificationStore.setSuccessMessage('Customer deleted successfully!');
          loadData();
        }
      } catch (e) {
        captureException(e);
      } finally {
        setLoading(false);
      }
    },
    [onCloseDeleteModal, history, loadData]
  );

  // edit customer detail
  const onClickEdit = useCallback(
    (item: CustomerDetailsInterface) => {
      customerStore.setCustomerDetail(item);
      setOpenCustomerModel(true);
    },
    [customerStore]
  );

  // close customer model
  const closeCustomerModel = useCallback(async () => {
    await getIndividualCustomerDetail(params?.id);
    customerStore.clearCustomerDetail();
    setOpenCustomerModel(false);
  }, [params?.id, customerStore]);

  // delete customer member
  const onDeleteCustomerMember = useCallback(
    async (member_id: string | undefined) => {
      try {
        if (!member_id) return;
        setDeleteMemberLoading(true);
        const result = await deleteCustomerMember(member_id);
        if (result) {
          await getCustomerMembersList(params?.id);
          close();
        }
      } catch (e) {
        captureException(e);
      } finally {
        setDeleteMemberLoading(false);
      }
    },
    [params?.id]
  );

  // redirect to invoice detail page
  const onClickInvoice = useCallback(
    (invoiceId: string) => {
      setSelectedInvoice(null);
      history.push(ROUTES.INVOICE_DETAILS.replace(':id', invoiceId));
    },
    [history]
  );

  // close edit modal
  const onCloseEditModal = useCallback(async () => {
    customerStore.clearCustomerDetail();
    setIsEditModalOpen(false);
  }, [customerStore]);

  // handel upload click
  const handleUploadClick = useCallback(() => {
    inputRef.current?.click();
  }, []);

  // for convert base64
  const convertBase64 = useCallback(
    (file: File) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = async () => {
          const item = {
            profile: fileReader.result,
            file: file
          };
          let profileUrl;
          if (item) {
            profileUrl = await getFirebaseUrlFromFile(item, 'customer-profile/', individualCustomer?.id);
          }
          customerStore.updateCustomerDetail('profileImage', profileUrl);
          const payload = {
            ProfileImage: profileUrl
          };
          const response = await updateCustomerData(individualCustomer?.id, payload);
          if (response) rootStore.alertNotificationStore.setSuccessMessage('Customer profile updated successfully!');
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    },
    [customerStore, individualCustomer?.id]
  );

  // handle file read
  const handleFileRead = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const file = event.target.files?.[0];
        if (!file) return;
        let fileData = file?.name.split('.');
        if (file.size > 500000) {
          rootStore.alertNotificationStore.setErrorMessage('Please upload less than 500kb photo size.');
          return false;
        }
        if (fileData[1] === 'jpg' || fileData[1] === 'jpeg' || fileData[1] === 'png') {
          await convertBase64(file);
        } else {
          rootStore.alertNotificationStore.setErrorMessage('Please upload a valid type photo.');
          return false;
        }
      } catch (e) {
        captureException(e);
      }
    },
    [convertBase64]
  );

  // handle click for (edit and delete)
  const handleClick = useCallback(
    (key: number | string, item: CustomerDetailsInterface) => {
      const numericKey = Number(key);
      if (numericKey === MENU_OPTIONS.EDIT) {
        onClickEdit(item);
      } else if (numericKey === MENU_OPTIONS.DELETE) {
        onClickDelete(item);
      }
    },
    [onClickDelete, onClickEdit]
  );

  // render more menu items
  const renderMoreMenuItems = useCallback(
    (item: CustomerDetailsInterface) => {
      return CustomerDetailMoreMenu.map((menuItem) => (
        <DropdownItem
          key={menuItem.key}
          label={menuItem.label}
          onClick={() => handleClick(menuItem.key, item)}
          tone={menuItem.label === 'Delete' ? 'critical' : 'primary'}
        />
      ));
    },
    [handleClick]
  );

  // common component for manage customer dropdown
  const renderManageCustomerDropdown = useMemo(
    () => (
      <Dropdown
        modalTitle='Manage Customer'
        activeClassName='active'
        content={
          isMobile ? (
            <BottomNavigationItem iconName='three-dots-horizontal-icon' />
          ) : (
            <IconButton
              iconName='three-dots-horizontal-icon'
              size={ICON_BUTTON_SIZE.SMALL}
              variant={ICON_BUTTON_TYPE.TERTIARY}
            />
          )
        }
        trigger='click'>
        {renderMoreMenuItems(individualCustomer)}
      </Dropdown>
    ),
    [individualCustomer, isMobile, renderMoreMenuItems]
  );

  // common component of Header for desktop and responsive
  const HeaderComponent = useMemo(() => {
    const getProfileImageSrc = () => {
      if (!isEmpty(newCustomer?.profileImage)) return newCustomer.profileImage;
      if (!isEmpty(individualCustomer?.profileImage)) return individualCustomer.profileImage;
      return 'invoicing_empty_profile';
    };

    return (
      <>
        <LeftHeader>
          <input type='file' onChange={handleFileRead} ref={inputRef} hidden aria-label='Upload file' />
          <Profile>
            <ProfileImg>
              <Image
                imageUrl={getProfileImageSrc()}
                alt='empty-profile'
                width={isMobile ? 22 : 58}
                height={isMobile ? 22 : 58}
                className={
                  !isEmpty(newCustomer?.profileImage) || !isEmpty(individualCustomer?.profileImage)
                    ? 'img'
                    : 'empty-img'
                }
              />
              <Overlay role='button' className='edit-profile' onClick={handleUploadClick}>
                <EditIcon>
                  <SVGIcon
                    name='edit-icon'
                    width='26'
                    height='26'
                    viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                    fill='var(--text-white)'
                  />
                </EditIcon>
              </Overlay>
            </ProfileImg>
            <ProjectDetail>
              <h1>{individualCustomer?.companyName}</h1>
              {!isMobile && !isEmpty(individualCustomer?.email) && <p>{individualCustomer.email}</p>}
            </ProjectDetail>
          </Profile>
          <DropDiv>{renderManageCustomerDropdown}</DropDiv>
        </LeftHeader>
      </>
    );
  }, [
    handleFileRead,
    isMobile,
    newCustomer.profileImage,
    individualCustomer.profileImage,
    individualCustomer?.companyName,
    individualCustomer.email,
    handleUploadClick,
    renderManageCustomerDropdown
  ]);

  // render customer project list
  const renderCustomerProjectList = useMemo(() => {
    const getProjectDetails = (projectId: string) => projects?.find((item) => item?.id === projectId);
    const navigateToProject = (projectDetails: ProjectModel | undefined) => {
      if (projectDetails) {
        history.push(ROUTES.PROJECT_TASKS.replace(':id', projectDetails?.id || ''));
      } else {
        rootStore.alertNotificationStore.setErrorMessage("You don't have access to this project");
      }
    };
    return customerProjectList?.map((project) => {
      const projectDetails = getProjectDetails(project['_id']);
      const isArchived = projectDetails?.isArchived ?? project?.IsArchived ?? false;
      let projectIcon = projectDetails?.icon;
      if (!projectIcon) {
        projectIcon = {
          type: PROJECT_ICON_TYPE.DEFAULT,
          reference: '',
          color: getColorIndex(project?.Name || '')
        };
      }
      return (
        <>
          <ProjectCard
            projectId={project['_id']}
            projectName={project?.Name}
            projectIcon={projectIcon}
            progressData={projectDetails?.progressData}
            projectUsers={projectDetails?.users || project?.users}
            onClickProjectList={() => navigateToProject(projectDetails)}
            showCompanyName={false}
            applyTopSpacing={true}
            isArchived={!!isArchived}
          />
        </>
      );
    });
  }, [customerProjectList, projects, history]);

  // render customer invoice list
  const renderCustomerInvoiceList = useMemo(() => {
    return customerInvoiceList?.map((invoice, index) => {
      const ref = currencySymbols.find((x) => x.code === invoice?.currency);
      const symbol = ref?.symbol;

      if (!invoiceButtonRef?.current[index]) {
        invoiceButtonRef.current[index] = React.createRef<HTMLDivElement>();
      }
      return (
        <>
          <TableTr
            role='button'
            isActive={selectedInvoice === invoice?.id}
            key={invoice?.id}
            onClick={() => onClickInvoice(invoice?.id)}>
            <TableDataGroup>
              <TableData>
                <InvoiceNumber>{invoice?.number}</InvoiceNumber>
              </TableData>
              <TableData>
                <CompanyDetails isCustomerDetailInvoice={true}>
                  <CustomerName>{getFormattedDate(new Date(invoice?.date))}</CustomerName>
                  {calculateDueTime(invoice?.dueDate)?.overDue && (
                    <CompanyName>{calculateDueTime(invoice?.dueDate)?.dueTime}</CompanyName>
                  )}
                </CompanyDetails>
              </TableData>
              <TableData>
                <CompanyDetails isCustomerDetailInvoice={true}>
                  <CustomerName>
                    {symbol} {Number(currencyWithDecimal(invoice?.totalAmount))}
                  </CustomerName>
                  {invoice?.dueAmount > 0 && (
                    <CompanyName>
                      Due {symbol} {invoice?.dueAmount}
                    </CompanyName>
                  )}
                </CompanyDetails>
              </TableData>
              <TableData>
                <InvoiceNumber status={invoice?.statusText}>{invoice?.statusText}</InvoiceNumber>
              </TableData>
            </TableDataGroup>
            <TableData>
              <Dropdown
                modalTitle='Invoice'
                activeClassName='active'
                content={
                  <DropDiv>
                    <IconButton
                      iconName='three-dots-horizontal-icon'
                      size={isMobile ? ICON_BUTTON_SIZE.MEDIUM : ICON_BUTTON_SIZE.SMALL}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      onClick={() => {
                        setSelectedInvoice((prev) => (prev === null ? invoice?.id : null));
                      }}
                      className='more-icon'
                    />
                  </DropDiv>
                }
                trigger='click'
                onOutsideClick={() => setSelectedInvoice(null)}>
                <DropdownItem label='View' onClick={() => onClickInvoice(invoice?.id)} />
              </Dropdown>
            </TableData>
          </TableTr>
        </>
      );
    });
  }, [customerInvoiceList, selectedInvoice, isMobile, onClickInvoice]);

  const renderProjectEmptyState = useCallback(() => {
    return (
      <EmptyStateV2
        title='You have no projects yet'
        size={EMPTY_STATE_SIZE.SMALL}
        imageUrl={'project_empty'}
        buttonTitle='New Project'
        onClick={OpenModal}
      />
    );
  }, [OpenModal]);

  return (
    <>
      <>
        <AppLayout>
          <Group>
            {loading && <CustomerDetailLoading />}
            {/*responsive view design for header */}
            {isMobile && <ResponsiveHeader title={individualCustomer?.companyName} noMargin={true} />}
            {!loading && (
              <MainDiv className='desktop-content'>
                <LeftContentDiv>
                  <LeftDiv>
                    {/* desktop view design for header and project card */}
                    {!isMobile && (
                      <>
                        {HeaderComponent}
                        <Project className={'web-project-section'}>
                          <Title>
                            <p>Projects</p>
                          </Title>

                          {/* Empty state */}
                          {customerProjectList?.length === 0 && !loading && <Empty>{renderProjectEmptyState()}</Empty>}
                          {customerProjectList?.length > 0 && !loading && (
                            <ProjectBox>{renderCustomerProjectList}</ProjectBox>
                          )}
                        </Project>
                      </>
                    )}
                    {
                      <>
                        <Invoice>
                          <Title>
                            <p>Invoices</p>
                          </Title>

                          {/* Empty state */}
                          {customerInvoiceList?.length === 0 && !loading && (
                            <Empty>
                              <EmptyStateV2
                                title='You have no invoice records.'
                                size={EMPTY_STATE_SIZE.SMALL}
                                imageUrl={'invoice_empty'}
                                buttonTitle='New Invoice'
                                onClick={onClickNewInvoice}
                              />
                            </Empty>
                          )}
                          {customerInvoiceList?.length > 0 && !loading && (
                            <TableWrapper>
                              <Table>
                                <TableHead>
                                  <tr>
                                    <TableHeadGroup>
                                      <TableHeader>
                                        <p>Invoice no</p>
                                      </TableHeader>
                                      <TableHeader>
                                        <p>Invoice Date</p>
                                      </TableHeader>
                                      <TableHeader>
                                        <p>Amount</p>
                                      </TableHeader>
                                      <TableHeader>
                                        <p>Status</p>
                                      </TableHeader>
                                    </TableHeadGroup>
                                    <TableHeader />
                                  </tr>
                                </TableHead>
                                <tbody>{renderCustomerInvoiceList}</tbody>
                              </Table>
                            </TableWrapper>
                          )}
                        </Invoice>
                      </>
                    }
                  </LeftDiv>
                </LeftContentDiv>
                <CustomerDetailRight
                  openDeleteModal={() => setDeleteModalOpen(true)}
                  setIsModalOpen={() => setIsModalOpen(true)}
                  openEditModal={() => setIsEditModalOpen(true)}
                  setSelectedItem={(value) => setSelectedItem(value)}
                />
                {/* Responsive view for Project Card  */}
                {isMobile && (
                  <Project className={'responsive-project-section '}>
                    <Title>
                      <p>Projects</p>
                    </Title>

                    {/* Empty state */}
                    {customerProjectList?.length === 0 && !loading && <Empty>{renderProjectEmptyState()}</Empty>}
                    {customerProjectList?.length > 0 && !loading && (
                      <ProjectBox>{renderCustomerProjectList}</ProjectBox>
                    )}
                  </Project>
                )}
              </MainDiv>
            )}
          </Group>
        </AppLayout>
      </>
      <BottomSubNavigation rightElement={renderManageCustomerDropdown} />
      <Modal open={deleteModelOpen} onClose={close} maxWidth={'334px'}>
        <DeleteModal
          onClose={close}
          loading={deleteMemberLoading}
          onOk={() => onDeleteCustomerMember(selectedItem?.id)}
          modalTitle='Delete Member?'
          description='Are you sure you want to delete this member?'
        />
      </Modal>
      <Modal open={isModalOpen} onClose={handleCloseModal} maxWidth={'480px'}>
        <AddMemberModal closeModal={handleCloseModal} customer_id={individualCustomer?.id} />
      </Modal>
      <Modal open={isInvoiceModel} onClose={handleClose} maxWidth={'380px'}>
        <AddInvoiceModal
          closeModel={handleClose}
          isCustomerDetail={true}
          customerDetail={individualCustomer}
          CustomerInvoiceModal={true}
        />
      </Modal>
      <Modal open={openCustomerModel} onClose={closeCustomerModel} maxWidth={'692px'} isResponsiveMaxWidth={true}>
        <CustomerModal handleCloseModal={closeCustomerModel} />
      </Modal>
      <Modal open={isDeleteOpen} onClose={onCloseDeleteModal} maxWidth={'334px'}>
        <DeleteModal
          onClose={onCloseDeleteModal}
          onOk={() => onDeleteCustomer(individualCustomer)}
          loading={loading}
          modalTitle='Delete Customer?'
          description='Are you sure to want to delete this customer?'
        />
      </Modal>

      <Modal open={isEditModalOpen} onClose={onCloseEditModal} maxWidth={'692px'} isResponsiveMaxWidth={true}>
        <CustomerEditModal handleCloseModal={onCloseEditModal} />
      </Modal>
      <Modal open={isSuccessfulModalOpen} onClose={handleOnclickCloseModel} maxWidth={'420px'}>
        <SuccessFullModel clientLoginUrl={clientLoginUrl} onCancel={handleOnclickCloseModel} />
      </Modal>
    </>
  );
};

export default observer(CustomerDetail);
